import React, { Component } from 'react'
import { Button, Form, Modal, Input, message, Icon, Upload, Descriptions, Tag, Skeleton, Select } from 'antd'
import { withRouter } from 'react-router-dom'

import { bankInfo } from '_src/utils/tool'

import { setMerchant, getMerchant } from '_src/api/api'

import { UploadIMGToOss } from '_src/utils/base'
function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const { Option } = Select

@withRouter
@Form.create({ name: 'SetMerchant' })
class SetMerchant extends Component {
  constructor (props) {
    super(props)
    this.loading = true
    this.isNewSet = true
    this.upLoadFlage = true // 判断图片是否需要更新上传
    this.param = {
      status: '',
      pageNum: 0,
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      loading: true,
      baseInfo: {},
      typeList: [], // 商户类型选项
      visible: false,
      dataList: [],
      previewVisible: false,
      previewImage: '',
      // 图片集合
      fileList: {
        cover: [],
        businessLicense: [],
        idCardObverse: [],
        idCardReverse: []
      },
      erroMsg: '',
      submitting: false,
    }
  }

  componentDidMount () {
    this.setValue()
  }

  // 设值
  setValue = () => {
    this.getMerchant()
      .then(res=>{
        const { bank } = res
        console.log(bank)
        this.isNewSet = false
        this.upLoadFlage = false
        this.props.form.setFieldsValue({
          ...res.formInfo,

        })
        const { imgInfo } = res
        const fileList = {}
        for (let x in imgInfo) {
          fileList[x] = [{ uid: `${x}_img`, name: x, status: 'done', url: imgInfo[x]}]
        }
        this.setState((preState)=>({
          baseInfo: {...preState.baseInfo, ...res.baseInfo},
          fileList,
          loading: false
        }))
      })
      .catch(err=>{
        const {firstLoad} = err
        if (firstLoad) {
          const { baseInfo } = err
          this.setState((preState)=>({
            baseInfo: {...preState.baseInfo, ...baseInfo},
            loading: false
          }))
        }
        this.upLoadFlage = false
      })
  }
  getMerchant () {
    return new Promise((resove, reject)=>{
      getMerchant()
        .then(res =>{ 
          const { data } = res
          
          // 商家基础信息
          const { storeName, merchantName, status, bank } = data
          // Form基础信息
          const { mobile, shopAddress, returnContact, returnAddress, bankCard, shopIntroduction } = data
          // 图片链接
          const { idCardObverse, idCardReverse, cover, businessLicense} = data
          const baseInfo = { storeName, merchantName, status }
          const imgInfo = { idCardObverse, idCardReverse, cover, businessLicense}
          if (idCardObverse&&idCardReverse) {
            const formInfo = { mobile, shopAddress, returnContact, returnAddress, bankCard, shopIntroduction, bank }
            resove({formInfo, baseInfo, imgInfo })
          }
          else {
            reject({firstLoad: true, baseInfo})
          }
        })
        .catch(err =>{
          reject(err)
          message.error('请求失败')
        })
    })
  }

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    })
  };

  handleChange = (files, key) => {
    this.upLoadFlage = true
    this.setState({
      erroMsg: ''
    })
    
    // this.upLoadFlage = true
    this.setState((preState)=>(
      { 
        fileList: {...preState.fileList, [key]: files } 
      }
    ))
  }
  
  onSubmit = (e) => {
    e.preventDefault()
    if (this.state.submitting) return
    this.props.form.validateFields(async (err, values) => {
      // return
      if (!err) {
        const { fileList } = this.state
        const { cover } = fileList
        if (cover.length === 0) {
          this.setState({
            erroMsg: '图片不能为空'
          })
          return
        }
        else {
          this.setState({ submitting: true })
          this.hide = message.loading(this.id?'商铺修改中':'商铺设置中', 0)
          // 需要更新图片
        
          let imgUrl = {}
            
          for (let key in fileList) {
            try {
              const file = fileList[key][0]
              if (!!file) {
                if (!!file.url) {
                  imgUrl[key] = file.url
                }
                else {
                  const x = await UploadIMGToOss(fileList[key][0])
                  imgUrl[key] = x
                }
              }
            } catch (e) {
              this.hide()
              this.setState({ submitting: false })
              message.error('图片上传失败！', 1.5)
              return false
            }
          }
          const param = {...values, ...imgUrl}
          this.setMerchant(param)
          
          this.setState({
            erroMsg: ''
          })
        }
      }
    })
  }

  // 商铺设置
  setMerchant (param) {
    setMerchant(param)
      .then(()=>{
        this.hide && this.hide()
        this.setState({ submitting: false })
        message.success('设置成功', 1.5)
        const { newSet } = this.props
        if (newSet) {
          this.props.history.replace('/home')
        }
      })
      .catch(() => {
        this.hide && this.hide()
        this.setState({ submitting: false })
        message.error('设置失败', 1.5)
      })
  }

  
  render () {
    const { previewVisible, previewImage, fileList, erroMsg, baseInfo } = this.state
    const { getFieldDecorator } = this.props.form
    const uploadButton = (title) => (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">{title}</div>
      </div>
    )
    return (
      <div className = "SetMerchant page_content">
        <Skeleton loading={this.state.loading} active paragraph={{ rows: 8 }} >
       
        
          <div className = "top" style = {{margin: 'auto', marginBottom: 60, maxWidth: 900}} >
            {baseInfo.storeName
              ?<Descriptions title="商铺基础信息" bordered layout="horizontal">
                <Descriptions.Item label="店主名称">{baseInfo.storeName}</Descriptions.Item>
                <Descriptions.Item label="点击名称">{baseInfo.merchantName}</Descriptions.Item>
                <Descriptions.Item label="商家状态">{
                  !!baseInfo.status
                    ?<Tag color="green">有效</Tag>
                    :<Tag color="red">无效</Tag>
                }</Descriptions.Item>
              </Descriptions>
              :null}
          </div>
        
          <Form 
            onSubmit={this.onSubmit} 
            className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}
            style = {{maxWidth: 600, margin: (0, 'auto') }}
          >
          

            <Form.Item label="联系方式" hasFeedback>
              {getFieldDecorator('mobile', { rules: [
                { required: true, message: '联系方式不能为空', }, 
                {whitespace: true, message: '不允许存在空格'},
                { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的联系方式', }] })(
                <Input placeholder="请输入联系方式" />)}
            </Form.Item>
            <Form.Item label="商铺地址" hasFeedback>
              {getFieldDecorator('shopAddress', { rules: [{ required: true, message: '商铺地址不能为空', }] })(
                <Input placeholder="请输入商铺地址" />)}
            </Form.Item>
            <Form.Item label="退货联系" hasFeedback >
              {getFieldDecorator('returnContact', { rules: [
                { required: true, message: '退货联系方式不能为空', },
                {whitespace: true, message: '不允许存在空格'},
                { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的退货联系', }] })(
                <Input placeholder="请输入退货联系方式" />)}
            </Form.Item>
            <Form.Item label="退货地址" hasFeedback>
              {getFieldDecorator('returnAddress', { rules: [{ required: true, message: '退货地址不能为空', }] })(
                <Input placeholder="请输入退货地址" />)}
            </Form.Item>
            <Form.Item label="银行卡类型">
              {getFieldDecorator('bank', {
                rules: [
                  { required: true, message: '银行卡类型不能为空'},
                ],
              })(
                <Select placeholder="请选择银行卡类型">
                  {
                    bankInfo.map(item=>{
                      return (<Option value = {item.id} key = {item.id}>{item.name}</Option>)
                    })
                  }
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="银行卡" hasFeedback>
              {getFieldDecorator('bankCard', {
                rules: [
                  {
                    required: true,
                    message: '银行卡不能为空',
                  },
                  {
                    whitespace: true,
                    message: '不允许存在空格'
                  },
                  {
                    pattern: /^([1-9]{1})(\d{ {4}}|\d{18})$/,
                    message: '请输入正确银行卡'
                  }
                ],
              })(<Input placeholder="请输入银行卡" />)}
            </Form.Item>
            <Form.Item label="商铺介绍" hasFeedback>
              {getFieldDecorator('shopIntroduction')(
                <Input.TextArea placeholder="请输入商铺介绍" />)}
            </Form.Item>
            <Form.Item label='图片上传' validateStatus = "error" help={erroMsg}>
              <div style = {{ display: 'flex'}}>
            
                <Upload
                  action=""
                  listType="picture-card"
                  fileList={fileList.cover}
                  onPreview={this.handlePreview}
                  onChange={({fileList}) => this.handleChange(fileList, 'cover')}
                  beforeUpload = {()=>{ return false }}
                >
                  {fileList.cover.length >= 1 ? null : uploadButton(<FormLabel text = {'商铺头像450*450'} />)}
                </Upload>
    
                <Upload
                  action=""
                  listType="picture-card"
                  fileList={fileList.businessLicense}
                  onPreview={this.handlePreview}
                  onChange={({fileList}) => this.handleChange(fileList, 'businessLicense')}
                  beforeUpload = {()=>{ return false }}
                >
                  {fileList.businessLicense.length >= 1 ? null : uploadButton(<FormLabel text = "营业执照" />)}
                </Upload>
                <Upload
                  action=""
                  listType="picture-card"
                  fileList={fileList.idCardObverse}
                  onPreview={this.handlePreview}
                  onChange={({fileList}) => this.handleChange(fileList, 'idCardObverse')}
                  beforeUpload = {()=>{ return false }}
                >
                  {fileList.idCardObverse.length >= 1 ? null : uploadButton(<FormLabel text = "法人身份证正面" />)}
                </Upload>
                <Upload
                  action=""
                  listType="picture-card"
                  fileList={fileList.idCardReverse}
                  onPreview={this.handlePreview}
                  onChange={({fileList}) => this.handleChange(fileList, 'idCardReverse')}
                  beforeUpload = {()=>{ return false }}
                >
                  {fileList.idCardReverse.length >= 1 ? null : uploadButton(<FormLabel text = "法人身份证反面" />)}
                </Upload>

            
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                  <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
              </div>
            </Form.Item>
          
            <Form.Item style={{ paddingLeft: 140, textAlign: 'center' }}>
              <Button type="primary" htmlType="submit" icon='save' loading={this.state.submitting} disabled={this.state.submitting} style={{ width: 248}}>保存</Button>
            </Form.Item>
          </Form>
        </Skeleton>
      </div>
    )
  }
}

const FormLabel = (props) => {
  const { text } = props
  return (
    <span><i style = {{color: 'red', marginRight: 6}}>*</i>{text}</span>
  )
}

export default SetMerchant